import { ActionTree } from 'vuex';
import RootState from '@/types/store/booking/RootState';
import I18nState from '@/types/store/i18n/I18nState';

import CommonApi from '@/app/api/CommonApi';
import { switchRequestDefaultLanguage } from '@/app/core/request';

const actions: ActionTree<I18nState, RootState> = {
  switchLocale({ dispatch, commit }, locale: string | null): void {
    const value = locale || 'en';
    commit('setLocale', value);
    localStorage.setItem('welcmLanguage', value);
    switchRequestDefaultLanguage(value);
  },
  fetchTranslations({ commit, rootState, getters }): Promise<void> {
    const locale = getters.locale;
    const communeId = rootState.communeSelected;

    return CommonApi.getTranslationMessages(communeId, locale).then(data => commit('setTranslations', data));
  },
};

export default actions;
